export default {
    "name": "InitialLoadQuery",
    "kind": "HoudiniQuery",
    "hash": "7087b02fd4f4cce9b62703667aae8b1b7e087ac493b8127aeb8a1d02173ba0f7",

    "raw": `query InitialLoadQuery($filter: UserAccountFilter) {
  shippingMethods {
    id
    name
  }
  userAccounts(filter: $filter) {
    id
    name
  }
  taxItems {
    id
    name
  }
  salesOrderDocumentTypes {
    id
    name
  }
  salesOrderTerms {
    id
    name
    chargeDays
    chargeDayOfMonth
  }
  settingValues {
    salesOrders {
      showSequentialInvoiceNumbers
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "shippingMethods": {
                "type": "ShippingMethod",
                "keyRaw": "shippingMethods",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "userAccounts": {
                "type": "UserAccount",
                "keyRaw": "userAccounts(filter: $filter)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "taxItems": {
                "type": "TaxItem",
                "keyRaw": "taxItems",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "salesOrderDocumentTypes": {
                "type": "SalesOrderDocument",
                "keyRaw": "salesOrderDocumentTypes",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "salesOrderTerms": {
                "type": "Term",
                "keyRaw": "salesOrderTerms",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true,
                            "nullable": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "chargeDays": {
                            "type": "Int",
                            "keyRaw": "chargeDays",
                            "nullable": true,
                            "visible": true
                        },

                        "chargeDayOfMonth": {
                            "type": "Int",
                            "keyRaw": "chargeDayOfMonth",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "settingValues": {
                "type": "SettingValues",
                "keyRaw": "settingValues",

                "selection": {
                    "fields": {
                        "salesOrders": {
                            "type": "SalesOrderSettingValues",
                            "keyRaw": "salesOrders",

                            "selection": {
                                "fields": {
                                    "showSequentialInvoiceNumbers": {
                                        "type": "Boolean",
                                        "keyRaw": "showSequentialInvoiceNumbers",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "filter": "UserAccountFilter"
        },

        "types": {
            "UserAccountFilter": {
                "authorizedStores": "UInt",
                "id": "UInt",
                "isSalesPerson": "Boolean",
                "name": "String",
                "status": "UserAccountStatusEnum"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=74ca542df622bf901b58fff5ff728842a27bce5d08d8a4ef11dac9cc572430fc";